import React from 'react';
import { useSelector } from 'react-redux';
import { selectStoreCount } from 'core/selectors/app';
import { selectUserName } from 'core/selectors/user';

import config from './configs';

function Welcome({
  handleWelcomeDoneClick,
  sequenceValue,
}) {
  const storeCount = useSelector(selectStoreCount);
  const userName = useSelector(selectUserName);
  const { getWelcomeText, welcomeCTAText } = config;

  const welcomeText = getWelcomeText(storeCount);

  return (
    <>
      <div className="mn_onboardingWelcome">
        <div className="mn_brandLogo" />
        <h2>Welcome{userName ? `, ${userName}` : ''}<span className="mn_dot">.</span></h2>
        <p>{welcomeText}</p>
      </div>
      <div className="mn_bottomContent">
        <button
          className="mn_stepButton mn_stepWelcomeDone mn_button"
          onClick={handleWelcomeDoneClick}
          data-sequence-value={sequenceValue}
        >
          {welcomeCTAText}
        </button>
      </div>
    </>
  );
}

export default Welcome;
